import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-loadingcube',
    templateUrl: './loadingcube.component.html',
    styleUrls: ['./loadingcube.component.scss'],
    standalone: false
})
export class LoadingcubeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
